import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 pb-0 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_3 = { class: "col-12 py-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_First_Name_Label",
  for: "referral-first-name"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "A1110A"),
  /*#__PURE__*/_createTextVNode(" What is your preferred language? "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_7 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_First_Name_Label",
  for: "referral-first-name"
}, " Additional Language ", -1 /* HOISTED */)
const _hoisted_9 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_First_Name_Label",
  for: "referral-first-name"
}, " Additional Language ", -1 /* HOISTED */)
const _hoisted_11 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_First_Name_Label",
  for: "referral-first-name"
}, " Additional Language ", -1 /* HOISTED */)
const _hoisted_13 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_First_Name_Label",
  for: "referral-first-name"
}, " Auxiliary Aids ", -1 /* HOISTED */)
const _hoisted_15 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_16 = { class: "col-12 py-2" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_First_Name_Label",
  for: "referral-first-name"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "A1110B"),
  /*#__PURE__*/_createTextVNode(" Do you need or want an interpreter to communicate with a doctor or health care staff? "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_20 = { class: "form-check custom-radio pb-1" }
const _hoisted_21 = ["checked"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "no"
}, " No ", -1 /* HOISTED */)
const _hoisted_23 = { class: "form-check custom-radio pb-1" }
const _hoisted_24 = ["checked"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "yes"
}, " Yes ", -1 /* HOISTED */)
const _hoisted_26 = { class: "form-check custom-radio pb-1" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "unable"
}, " Unable to Determine ", -1 /* HOISTED */)
const _hoisted_29 = {
  key: 0,
  class: "col-12 py-2 px-0"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " Interpreter")
  ])
], -1 /* HOISTED */)
const _hoisted_31 = { class: "form-check custom-checkbox pb-1" }
const _hoisted_32 = ["id", "value", "onChange"]
const _hoisted_33 = ["for"]
const _hoisted_34 = {
  key: 0,
  class: "d-flex bg-white flex-column pb-4 ms-4"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "mb-1 mt-1 service-required-text-color" }, "Other Interpreter", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Patient Language",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.currentApplication)
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_TypeaheadInput, {
                  id: "Referral_Preferred_Language",
                  getData: _ctx.getLanguagesFilter,
                  value: _ctx.referral.Demographics.PreferredLanguage,
                  onValueChanged: _ctx.updateLanguage,
                  "show-all-by-default": true,
                  "open-on-focus": true,
                  placeholder: "Enter Preferred Langauge",
                  isError: _ctx.preferredLanguageError
                }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "isError"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_Preferred_Language",
                  name: "referral-preferred-language",
                  class: "form-control",
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter Text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.Demographics.AdditionalLanguage1) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Demographics.AdditionalLanguage1]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_Preferred_Language",
                  name: "referral-preferred-language",
                  class: "form-control",
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter Text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referral.Demographics.AdditionalLanguage2) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Demographics.AdditionalLanguage2]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_Preferred_Language",
                  name: "referral-preferred-language",
                  class: "form-control",
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter Text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.Demographics.AdditionalLanguage3) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Demographics.AdditionalLanguage3]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_auxiliary_aid",
                  name: "referral-auxiliary_aid",
                  class: "form-control",
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter Type",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.Demographics.AuxiliaryAids) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Demographics.AuxiliaryAids]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", {
                  class: _normalizeClass(`${
                                        _ctx.v$.referral.Demographics.NeedInterpreter.$error ||
                                        _ctx.errors.Demographics.includes('NeedInterpreter')
                                            ? 'border border-warning rounded p-2'
                                            : ''
                                    }`)
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input",
                      id: "no",
                      value: "0",
                      checked: _ctx.referral.Demographics.NeedInterpreter === '0',
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleNeedInterpreterChange('0'))),
                      onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.NeedInterpreter.$touch && _ctx.v$.referral.Demographics.NeedInterpreter.$touch(...args)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_21),
                    _hoisted_22
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input",
                      id: "yes",
                      value: "1",
                      checked: _ctx.referral.Demographics.NeedInterpreter === '1',
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleNeedInterpreterChange('1'))),
                      onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.NeedInterpreter.$touch && _ctx.v$.referral.Demographics.NeedInterpreter.$touch(...args)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_24),
                    _hoisted_25
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input",
                      id: "unable",
                      value: "2",
                      checked: _ctx.referral.Demographics.NeedInterpreter === '2',
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleNeedInterpreterChange('2'))),
                      onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.NeedInterpreter.$touch && _ctx.v$.referral.Demographics.NeedInterpreter.$touch(...args)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_27),
                    _hoisted_28
                  ])
                ], 2 /* CLASS */),
                (_ctx.referral.Demographics.NeedInterpreter == '1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _hoisted_30,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.interpreterOptionsOasisE, (interpreter) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input",
                            id: `interpreter-${interpreter.value}`,
                            value: interpreter.value,
                            onChange: ($event: any) => (_ctx.handleInterpreterRequired(interpreter.value))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_32),
                          _createElementVNode("label", {
                            class: "form-check-label mb-2",
                            for: `interpreter-${interpreter.value}`
                          }, _toDisplayString(interpreter.text), 9 /* TEXT, PROPS */, _hoisted_33)
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */)),
                      (_ctx.showOther())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _hoisted_35,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "100",
                              class: "ms-1 form-control w-90",
                              placeholder: "Enter Interpreter",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.referral.Demographics.InterpreterOther) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, _ctx.referral.Demographics.InterpreterOther]
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}